export default class ControllerSymbolsProvider {
  constructor({ controllerReels, callback, symbolId, delay = 100 }) {
    this.controllerReels = controllerReels;
    this.provideCallback = callback;
    this.targetSymbolId = symbolId;

    this.delay = delay;
    this.stack = [];
    this._exceptions = [];
  }

  start = () => {
    this._createStack();
    requestAnimationFrame(this._tryToProvideSymbol);
  };

  stop() {
    this.stack = [];
  }

  _tryToProvideSymbol = (timestamp) => {
    if (!this.stack.length) {
      this._prevTimestamp = null;
      return;
    }

    if (!this._prevTimestamp) this._prevTimestamp = timestamp;
    const diff = timestamp - this._prevTimestamp;
    if (Math.floor(diff / this.delay) >= 1) {
      this.provideCallback({ symbol: this.stack.shift(), complete: !this.stack.length });
      this._prevTimestamp = timestamp;
    }

    requestAnimationFrame(this._tryToProvideSymbol);
  };

  _createStack() {
    this.stack = [];

    for (let reelIndex = 0; reelIndex < this.controllerReels.reels.length; reelIndex++) {
      for (let symbolIndex = this.controllerReels.topSimbolsCount; symbolIndex < this.controllerReels.reels[reelIndex].symbols.length - this.controllerReels.bottomSimbolsCount; symbolIndex++) {
        const symbol = this.controllerReels.reels[reelIndex].symbols[symbolIndex];
        if (this._isTarget(symbol.id) && !this._exceptions.includes(symbol)) {
          this.stack.push(this.controllerReels.reels[reelIndex].symbols[symbolIndex]);
        }
      }
    }
  }

  _isTarget(id) {
    if (Array.isArray(this.targetSymbolId)) {
      return this.targetSymbolId.includes(id);
    } else {
      return this.targetSymbolId === id;
    }
  }

  get exceptions() {
    return this._exceptions;
  }

  set exceptions(value) {
    this._exceptions = value;
  }
}
